import React, {useState, useEffect} from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components'
import SingleNumberResult from "../tool/SingleNumberResult";


export default  function Hint({content, counter}) {
    const [show, setShow] = useState(false)
    useEffect(() => {
        if(content) {
            window.parseKatexText()
        }

    })
    return (
        <Wrapper>
            <Header onClick={() => setShow(!show)}>Hint {counter}</Header>
            {show ? (<Content><div className={'latex-content'}>{content}</div></Content>) : null}

        </Wrapper>
    );
}

const Content = styled.div`
  padding: 4px;
`

const Header = styled.div`
  cursor: pointer;
  background-color: #313539;
  border-radius: 4px;
  margin-bottom: 4px;
  margin-top: 4px;
  padding: 4px;
  color: white;
`

const Wrapper = styled.div`

`


if (document.getElementsByTagName('hint')) {
    const elements = document.getElementsByTagName('hint')

    for(let element of elements) {
        ReactDOM.render(
            <Hint
                content={element.attributes.content.value}
                counter={element.attributes.counter.value}
            />, element);
    }

}
